import { render, staticRenderFns } from "./HtmlEmoji.vue?vue&type=template&id=39143358&scoped=true&"
import script from "./HtmlEmoji.vue?vue&type=script&lang=js&"
export * from "./HtmlEmoji.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEmoji.vue?vue&type=style&index=0&id=39143358&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39143358",
  null
  
)

export default component.exports